import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const GLOBAL = require('../../Globals');

class ElectiveSubject extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			_subcode : null,
			_subname : null,
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			secs : [],
			subj : [],
			stud : [],
			cls : '',
			section : '',
			subject : '',
			data : [],
			accyear : [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("subform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('subject/deleteelectsub',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Elective Subject Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Elective Subject',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.acyear && this.state.cls && this.state.section && this.state.subject && this.state.value){
			
			PostData('subject/addelectsub',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Elective Subject Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		this.getclass();
		this.getstudent();
		this.getdata();
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Student **/
	getstudent(){
		
		GetData('student/getstuddetails').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					stud : responseJson
				});
			}
		});
	}
	
	getdata(){
		
		GetData('subject/getelectsub').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
  render() {
	  
	  var items = this.state.posts;
	  var sec = this.state.secs;
	  var sub = this.state.subj;
	  var acyear = this.state.accyear;
	  
	  /** map Subject value to react multi select **/
	var val = this.state.stud.map(function(e,key) {
	   return (
		 {value : e.id, label : e.stdname}
	   );
	});
	
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		var ar = $("#year").val();
		$.get(GLOBAL.BASE_URL+'section/getsecbyclass/'+ar+'/'+fr,function(o){
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});	
			
		},'json');
	
	});
	
	/** get Subject By Class & Section **/
	$("#secs").change(function(){
		var cr = $("#clas").val();
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'subjectallocation/getsubjectbysec/'+cr+'/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#sub").html('');
			$('#sub')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Subject- ')); 
			$.each(o,function(key,value){			
				   $('#sub')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.subname)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Add Elective Subject</strong>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Academic Year <span className="text-danger">*</span></Label>
							  <select name="acyear" className="form-control" onChange={this.onChange} required id="year">
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <select name="cls" onChange={this.onChange} className="form-control" id="clas" required> 
								<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <select name="section" onChange={this.onChange} className="form-control" id="secs" required>
											
							  </select>
							</FormGroup>
						  </Col>
						   <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
							  <select name="subject" onChange={this.onChange} className="form-control" id="sub" required>
											
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Student <span className="text-danger">*</span></Label>
							  <Select value={this.state.value} onChange={this.handleChange} multi options={val} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			  <Col md="7">
			   <Card>
				<CardBody>
				<Table responsive bordered>
					<thead>
						<tr>
							<th>S.No</th>
							<th>Academic Year</th>
							<th width="70">Class</th>
							<th>Section</th>
							<th>Student</th>
							<th>Subject</th>
							<th>Manage</th>
						</tr>
					</thead>
					<tbody>
						{this.state.data.map(item =>
						 
							<tr key = {item}>
								<td>{item.id}</td>
								<td>{item.acyear}</td>
								<td>{item.cls}</td>
								<td>{item.sec}</td>
								<td>{item.sub}</td>
								<td>{item.studname}</td>
								<td>
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>

						 )}
					</tbody>
				</Table>
				</CardBody>
			   </Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default ElectiveSubject;


// WEBPACK FOOTER //
// ./src/subject/ElectiveSubject/ElectiveSubject.js